import React, {useState,useEffect} from 'react'
import {motion } from "framer-motion"
import {images} from '../../constants'
import './About.scss'
import { urlFor, client } from '../../client';
import { AppWrap , MotionWrap } from '../../wrapper'



const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';

    client.fetch(query).then((data) => {
      setAbouts(data);
    });
  }, []);

  
  

  return (
    <>
    <h2 className='head-text'>I Create <span> Web Solutions</span><br/>That Fuels<span>  Business Growth.</span><br />  </h2>
    <div className="app__profile">
      {abouts.map((about, index) =>(
        <motion.div
        whileInView={{opacity:1}}
        whileHover={{scale:1.1}}
        transition={{duration:0.5, type:'tween'}}
        className='app__profile-item '
        key={about.title + index}
        >
          <img src={urlFor(about.imgUrl)} alt="ye ek tasweer hai jo abhi nhi dikh rahi 2 sec ruko ajaegi" />
          <h2 className='bold-text' style={{marginTop: 20}}>{about.title}</h2>
          <p className='p-text' style={{marginTop: 10}}>{about.description}</p>

        </motion.div>
      )) }
    </div>
    
    
    </>
  )
}

export default AppWrap(
  MotionWrap(About, ),
  'about',
  'app__whitebg',
);